import { useMemo } from 'react';
import useKey from 'react-use/lib/useKey';
var useShortcut = function useShortcut(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    handler = _ref.handler,
    options = _ref.options,
    shortcut = _ref.shortcut;
  var _shortcut$ctrlKey = shortcut.ctrlKey,
    ctrlKey = _shortcut$ctrlKey === void 0 ? false : _shortcut$ctrlKey,
    key = shortcut.key,
    _shortcut$metaKey = shortcut.metaKey,
    metaKey = _shortcut$metaKey === void 0 ? false : _shortcut$metaKey,
    _shortcut$shiftKey = shortcut.shiftKey,
    shiftKey = _shortcut$shiftKey === void 0 ? false : _shortcut$shiftKey;
  var predicate = useMemo(function () {
    return function (event) {
      if (disabled === false && key === event.key && ctrlKey === Boolean(event.ctrlKey) && shiftKey === Boolean(event.shiftKey) && metaKey === Boolean(event.metaKey)) {
        return true;
      }
      return false;
    };
  }, [disabled, key, ctrlKey, metaKey, shiftKey]);
  useKey(predicate, handler, options, [predicate, handler, options]);
};
export default useShortcut;